import { useDispatch } from "react-redux";
import { setFromDate, setToDate } from "..";

export const useFiltersActions = () => {
  const dispatch = useDispatch();

  return {
    updateFromDate: (date: Date | null) => dispatch(setFromDate(date)),
    updateToDate: (date: Date | null) => dispatch(setToDate(date)),
  };
};

